import { FormControl } from '@ngneat/reactive-forms';

export interface ClienteForm {
  filial: FormControl<number>;
  formaEntrega: FormControl<number>;
  regiaoTransportadora: FormControl<number>;
  formaPagamento: FormControl<number>;
  prazoPagamento: FormControl<number>;
  nomeDoDestinarario: FormControl<number>;
  cep: FormControl<number>;
  endereco: FormControl<number>;
  numero: FormControl<number>;
  complemento: FormControl<number>;
  bairro: FormControl<number>;
  cidade: FormControl<number>;
  estado: FormControl<number>;
}

export interface PaginatorResponse<T> {
  pageIndex?: number;
  total: number;
  data: T[];
  totalPage: number;
  totalPages: number;
}

export interface ClienteResponse {
  BAIRRO_COBRANCA: null | string;
  BAIRRO_COMERCIAL: string;
  BAIRRO_ENTREGA: null | string;
  BLOQUEIO: 'S' | 'N';
  LEAD_CLIENTE: 'S' | 'N';
  CELULAR: null | string;
  CEP_COBRANCA: null | string;
  CEP_COMERCIAL: string;
  CEP_ENTREGA: string;
  CIDADE_COBRANCA: null | string;
  CIDADE_COMERCIAL: string;
  CIDADE_ENTREGA: null | string;
  CLIENTE: string;
  COMPLEMENTO_COBRANCA: null | string;
  COMPLEMENTO_COMERCIAL: null | string;

  COMPLEMENTO_ENTREGA: null | string;
  CPFCNPJ: string;
  DOCUMENTO_ENTREGA: null | string;
  DTNASCIMENTO: string;
  DT_ALTERACAO: string;
  DT_CADASTRO: string;

  DT_EXCLUSAO: string;
  EMAIL: string;
  ID_CIDADE_COBRANCA: null | number;

  ID_CIDADE_COMERCIAL: number;
  ID_CIDADE_ENTREGA: null | number;
  ID_CLIENTE: number;
  ID_COBRANCA: 'D' | 'C' | 'E';
  ID_PARCELA: number;
  ID_PAIS: number;
  ID_PRACA: number;
  ID_RAMOATIVIDADE: number;
  ID_VEND1: number;
  ID_VEND2: number;
  ID_VENDEDOR: null | number;
  IE: 'ISENTO' | 'NAO_INFORMADO' | 'NÃO_ISENTO' | 'NÃO_INFORMADO';
  LOGRADOURO_COBRANCA: null | string;
  LOGRADOURO_COMERCIAL: string;
  LOGRADOURO_ENTREGA: null | string;
  NOME_CLIENTE: string;
  NOME_FANTASIA: null | string;
  NOME_RAMOATIVIDADE: string;
  NUMERO_COBRANCA: null | string;
  NUMERO_COMERCIAL: null | string;
  NUMERO_ENTREGA: null | string;
  OBSERVACAO?: string;
  OBS_ENTREGA: string;
  OBS_GERENCIAL: null | string;
  PONTOREFERENCIA_COBRANCA: null | string;
  PONTOREFERENCIA_COMERCIAL: null | string;
  PONTOREFERENCIA_ENTREGA: null | string;
  RG_EMISSOR: null | string;
  RG_NUMERO: string;
  SENHA_WEB: null | string;
  STATUS: number;
  TELEFONE1: null | string;
  TELEFONE2: null | string;
  TEL_COBRANCA: null | string;
  TEL_ENTREGA: null | string;
  TIPODOC_ENTREGA: null | string;
  TIPOFJ: 'F' | 'J';
  TIPOVENDACLI: null | number[];

  UF_COBRANCA: null | string;
  UF_COMERCIAL: string;
  UF_ENTREGA: null | string;
  atacarejo: string;

  LIMITECREDITO?: number;
}

export interface ClienteProxiInatResponse {
  data: string;
  codcli: number;
  cliente: string;
  cgcent: string;
  qT_PEDIDOS: number;
  vL_TOTAL: number;
}

export const CUSTOMER_PORTFOLIO_TYPE = {
  NEXT_INACTIVE: 'próximos inativos',
  ACTIVE: 'ativos',
  INACTIVE: 'inativos',
} as const;

export type CustomerPortfolioType =
  (typeof CUSTOMER_PORTFOLIO_TYPE)[keyof typeof CUSTOMER_PORTFOLIO_TYPE];

export const CUSTOMER_PORTFOLIO_CHECKBOXES = {
  [CUSTOMER_PORTFOLIO_TYPE.NEXT_INACTIVE]: 'quaseinativos',
  [CUSTOMER_PORTFOLIO_TYPE.ACTIVE]: 'ativos',
  [CUSTOMER_PORTFOLIO_TYPE.INACTIVE]: 'inativos',
};

export type CustomerPortfolioCheckboxes =
  (typeof CUSTOMER_PORTFOLIO_CHECKBOXES)[keyof typeof CUSTOMER_PORTFOLIO_CHECKBOXES];
